import { useAppDispatch, useAppSelector } from "../../store/hooks";
import { getPhone } from "../../store/login/action";
import { useEffect, useRef, useState } from "react";
import { loginAction } from "../../store/login/slice";
import { Loadingbtn } from "../loading/Loading";
import style from "./request.module.css";
import Button from "../button/Button";
import { configAction } from "../../store/config/slice";
import { vibratePhone } from "../../helpers/share";
import { ModalStep } from "../../types/config";
import { toEnglishNumber } from "../../helpers/converting";
const PhoneRequest = () => {
  const dispatch = useAppDispatch();
  const inputRef = useRef<HTMLInputElement>(null);
  const { request, userPhone } = useAppSelector((state) => state.login);
  const [activeBtn, setActiveBtn] = useState(false);

  const handleRequestPhone = function () {
    const pattern = /^(\+98?)?{?(0?9[0-9]{9,9}}?)$/gm;
    const phoneVlaid =
      pattern.test(userPhone) &&
      userPhone.trim().length === 11 &&
      userPhone.startsWith("09");
    if (userPhone.trim().length === 0) {
      inputRef.current?.focus();
    } else if (phoneVlaid) {
      dispatch(getPhone(userPhone, "sms"));
      inputRef.current?.blur();
    } else {
      inputRef.current?.blur();
      vibratePhone(100);
      dispatch(
        loginAction.setRequestError("شماره موبایل خود را به درستی وارد کنید")
      );
    }
  };
  const handleRule = function () {
    dispatch(configAction.setModalStep(ModalStep.RULE));
  };
  return (
    <>
      <div className={style.phone}>
        <div className={style["phone-inner"]}>
          <div className={style["top-box"]}>
            <div className={style.title}>
              <span>ورود به بانی‌شانس</span>
            </div>
            <label htmlFor="phone">
              <span>برای امتحان شانست، شماره موبایلت رو وارد کن:</span>
            </label>
            <div className={style["input-box"]}>
              <input
                style={{
                  border: request.error ? " 1px solid #9F002A" : "",
                }}
                value={userPhone}
                type="tel"
                name="phone"
                autoComplete="off"
                placeholder="شماره همراه مثل؛ ۰۹۱۲۳۴۵۶۷۸۹"
                maxLength={11}
                ref={inputRef}
                onChange={(e) => {
                  dispatch(
                    loginAction.setUserPhone(toEnglishNumber(e.target.value))
                  );
                  if (e.target.value.trim().length !== 0) {
                    setActiveBtn(true);
                  } else {
                    setActiveBtn(false);
                  }
                }}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    handleRequestPhone();
                  }
                }}
                onFocus={() => dispatch(loginAction.setRequestError(null))}
              />
            </div>
            {request.error && (
              <span className={style.error}> {request.error}</span>
            )}
          </div>
          <div className={style["down-box"]}>
            <div className={style["down-box-inner"]}>
              <p className={style.banirule}>
                ورود شما به معنای پذیرش{" "}
                <span onClick={handleRule}> شرایط و قوانین بانی‌مد</span> است.
              </p>
              <Button
                onclick={handleRequestPhone}
                text="ورود به بانی‌‌شانس"
                className={`${style.submit} ${
                  !activeBtn ? style.deactive : ""
                }`}
                loading={request.loading}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default PhoneRequest;
